import axios from "axios";

export const getProducts = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/products", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getProduct = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/products/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createProduct = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/products`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateProduct = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/products/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteProduct = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/products/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const restoreProduct = async ({ id }: any) => {
	try {
		const res: any = await axios.post(`/products/${id}/restore`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resyncProduct = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/products/${data?.id}/resync`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
